import { Link } from "react-router-dom";
import { Heart, Eye, MessageCircle } from "lucide-react";
import { AuthorBadge } from "@/components/site/AuthorBadge";
import { Seo, ORG_SCHEMA } from "@/components/site/Seo";

const IMG = "https://images.unsplash.com/photo-1450778869180-41d0601e046e?w=1400&q=80&auto=format&fit=crop";
const PROMISES = [
  [Heart, "Prima gli animali", "Se una polizza non ti serve, te lo diciamo. Preferiamo perdere una commissione che vederti pagare per niente."],
  [Eye, "Trasparenza totale", "Guadagniamo con link di affiliazione e lo scriviamo ovunque. Nessuna compagnia ci paga per essere 'la migliore'."],
  [MessageCircle, "Parole semplici", "Franchigia, massimale, carenza: traduciamo tutto in italiano. Come lo spiegheremmo a nostra nonna."],
];

export default function ChiSiamo() {
  return (
    <div className="mx-auto max-w-5xl px-4 lg:px-8 py-14" data-testid="chi-siamo-page">
      <Seo title="Chi siamo | Polizzapet.it" description="Siamo ragazzi animalisti: leggiamo le polizze pet al posto tuo e ti diciamo la verità, anche quando non ti serve nessuna." schema={ORG_SCHEMA} />
      <p className="label-mono text-emerald-500 mb-3">Chi siamo</p>
      <h1 className="font-display text-4xl sm:text-5xl font-extrabold tracking-tight max-w-3xl leading-[1.05]">Ragazzi con il pelo sui vestiti e le condizioni di polizza sottolineate.</h1>
      <div className="mt-8 space-y-4 text-base md:text-lg text-muted-foreground max-w-2xl leading-relaxed">
        <p>Polizzapet.it nasce da una serata al pronto soccorso veterinario. Uno di noi ha dovuto scegliere se operare il suo cane o pagare l'affitto. Ha scelto il cane, ovviamente. Ma nessuno dovrebbe trovarsi in quella stanza a fare quel conto.</p>
        <p>Da allora leggiamo polizze pet, ne parliamo con veterinari e famiglie, e raccontiamo quello che scopriamo. Siamo animalisti, volontari in canile, e stiamo completando il percorso IVASS per diventare intermediari. Le due cose insieme, per noi, funzionano.</p>
      </div>
      <img src={IMG} alt="Ragazzi con un cane" className="mt-10 rounded-3xl w-full h-72 sm:h-96 object-cover" loading="lazy" />

      <section className="mt-16">
        <p className="label-mono text-emerald-500 mb-3">Come lavoriamo</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-8">Tre promesse</h2>
        <div className="grid gap-5 md:grid-cols-3">
          {PROMISES.map(([Icon, t, d]) => <div key={t} className="surface p-6"><span className="grid h-10 w-10 place-items-center rounded-lg bg-emerald-500/10 text-emerald-500 mb-4"><Icon size={20} /></span><h3 className="font-display text-lg font-bold mb-2">{t}</h3><p className="text-sm text-muted-foreground leading-relaxed">{d}</p></div>)}
        </div>
      </section>

      <section className="mt-16" data-testid="author-section">
        <p className="label-mono text-emerald-500 mb-3">Chi scrive</p>
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight mb-6">L'autore delle guide</h2>
        <AuthorBadge />
        <p className="text-sm text-muted-foreground mt-5 surface p-5 leading-relaxed">Fino all'iscrizione al RUI (Sezione E), Polizzapet.it svolge esclusivamente attività informativa e di comparazione: non intermedia contratti né raccoglie premi. Dettagli nella pagina <Link to="/trasparenza" className="text-emerald-600 underline">Trasparenza</Link>.</p>
      </section>

      <section className="section-dark rounded-3xl p-10 sm:p-14 mt-16 text-center">
        <h2 className="font-display text-2xl sm:text-3xl font-bold tracking-tight">Hai una domanda? Scrivici, rispondiamo noi.</h2>
        <p className="text-muted-foreground mt-3">Non un bot. Una persona con un cane che le dorme sui piedi.</p>
        <Link to="/consulenza" className="btn-primary mt-7" data-testid="chi-siamo-cta">Contattaci</Link>
      </section>
    </div>
  );
}
